import DOMPurify from "dompurify";

function escapeHtml(text) {
  return String(text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function sanitizeHref(href) {
  const raw = String(href || "").trim();
  if (!raw || /^javascript:/i.test(raw) || /^data:/i.test(raw)) return "#";
  return raw;
}

/** Render assistant markdown with DOMPurify (strips script, javascript: URLs, etc.). */
export function renderMarkdownLiteHtml(text) {
  const raw = String(text || "");
  const lines = raw.split("\n");
  const html = lines
    .map((line) => {
      const escaped = escapeHtml(line);
      const linked = escaped.replace(
        /\[([^\]]+)\]\(([^)]+)\)/g,
        (_, label, href) =>
          `<a href="${sanitizeHref(href)}" target="_blank" rel="noreferrer" class="text-[var(--primary)] underline underline-offset-2">${label}</a>`,
      );
      const bolded = linked.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
      return `<p class="text-sm leading-relaxed mb-2 last:mb-0">${bolded.replace(/\*([^*]+)\*/g, "<em>$1</em>")}</p>`;
    })
    .join("");
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "strong", "em", "a", "br"],
    ALLOWED_ATTR: ["href", "target", "rel", "class"],
    ALLOW_DATA_ATTR: false,
  });
}
